// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import PContactsOutlinedSvg from "@fishx/icons-svg/es/asn/PContactsOutlined";
import FishxIcon from '../components/FishxIcon';

var PContactsOutlined = function PContactsOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: PContactsOutlinedSvg
  }));
};

PContactsOutlined.displayName = 'PContactsOutlined';
export default React.forwardRef(PContactsOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/PContactsOutlined.js
// module id = 3303
// module chunks = 0